import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import "./style/scss/bootstrap.scss";
import "./style/_site.scss";
import VueCarousel from 'vue-carousel';
 

Vue.config.productionTip = false

Vue.use(VueCarousel);

new Vue({  
  router,
  store,
  render: h => h(App)
}).$mount('#app')

 
